module.exports = "mutation DeleteGroup($id: ID!) {\n  deleteGroup(id: $id) {\n    deleted\n  }\n}\n"